import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SeoArticleSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="px-4 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left side - label & avatars */}
          <div className="lg:w-[280px] flex-shrink-0 flex flex-col justify-between">
            <div>
              <span className="text-xs font-medium text-foreground-400 tracking-widest uppercase">
                {t('seo.label')}
              </span>
            </div>
            <div className="mt-8 lg:mt-auto">
              <span className="text-xs text-foreground-400">
                • {t('seo.badge')}
              </span>
              <div className="flex items-center gap-3 mt-4">
                <div className="flex -space-x-2">
                  {[
                    'https://readdy.ai/api/search-image?query=Warm%20professional%20portrait%20of%20european%20person%20on%20soft%20sage%20toned%20background%2C%20gentle%20natural%20lighting%20from%20window%2C%20approachable%20friendly%20expression%2C%20editorial%20headshot%20style%2C%20minimal%20clean%20composition&width=80&height=80&seq=avatar-v2-team-d1&orientation=squarish',
                    'https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20of%20european%20person%20on%20warm%20mushroom%20toned%20background%2C%20soft%20diffused%20studio%20light%2C%20confident%20calm%20expression%2C%20clean%20minimal%20headshot%2C%20refined%20composition&width=80&height=80&seq=avatar-v2-team-d2&orientation=squarish',
                    'https://readdy.ai/api/search-image?query=Warm%20natural%20portrait%20of%20european%20person%20on%20toasted%20almond%20background%2C%20gentle%20side%20lighting%2C%20genuine%20warm%20smile%2C%20professional%20editorial%20headshot%20style%2C%20minimal%20refined%20composition&width=80&height=80&seq=avatar-v2-team-d3&orientation=squarish',
                    'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20european%20person%20on%20warm%20sand%20colored%20background%2C%20soft%20directional%20natural%20light%2C%20friendly%20engaging%20expression%2C%20clean%20editorial%20style%2C%20minimal%20modern%20composition&width=80&height=80&seq=avatar-v2-team-d4&orientation=squarish',
                  ].map((src, i) => (
                    <div key={i} className="w-10 h-10 rounded-full border-2 border-background-100 overflow-hidden flex-shrink-0">
                      <img src={src} alt="" className="w-full h-full object-cover" loading="lazy" />
                    </div>
                  ))}
                </div>
                <div>
                  <p className="text-xs font-medium text-foreground-800">{t('seo.author_name')}</p>
                  <p className="text-xs text-foreground-500">{t('seo.author_desc')}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right side - article content */}
          <div className="flex-1 max-w-3xl">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-8 leading-snug">
              {t('seo.title')}
            </h2>
            <div className="text-foreground-700 leading-relaxed space-y-5 text-sm md:text-base">
              <p>{t('seo.paragraph1')}</p>
              <p>{t('seo.paragraph2')}</p>
              <p>{t('seo.paragraph3')}</p>
              <p>{t('seo.paragraph4')}</p>
              <p>{t('seo.paragraph5')}</p>
            </div>
            <Link
              to="/oopbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-8 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer group"
            >
              {t('seo.cta')}
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}